$(function(){
  console.log('template_collection.js');
  // collectionhandleを取得
  var collection_handle =$('[data-section-type="collection"]').attr('data-handle');
  let collection_type = '';
  // mo_で始まる場合は機種ごとにセット
  if(collection_handle.indexOf('mo_') !== -1){
    collection_type = 'model';
  }
  if(collection_handle.indexOf('iphone-14') !== -1){
    collection_type = 'model';
  }
  window.fox.settings.model_groups.forEach(function(group){
    if(collection_handle.indexOf(group.handle) !== -1){
      collection_type = 'model';
    }
  })
  let model_wide = $('[data-section-type="collection"]').attr('data-model-wide');
  if(model_wide == 'false'){
    collection_type = 'model';
  }

  const collection_template = $('[data-section-type="collection"]').attr('data-collection-template');

  const collection_allproducts = $('[data-section-type="collection"]').attr('data-collection-allproducts') || 64000000;
  const maxPage = collection_allproducts / 24;


  if(collection_type == 'model'){
    // 機種一覧
    // ---------------------------------
  }else{
    // 機種またぐ
    // ---------------------------------
    setWideModel();
    setAllProducts();
  }

  function setWideModel(){
    $('.js-section-product').each(function(){
      const $this = $(this);
      var tags = $(this).data('product-tags');
      let base_model_code = tags.find(function (code) {
        return code.indexOf('mo_') === 0;
      });
      let base_casetype_name = tags.find(function(code) {
        return code.indexOf('h1_') === 0;
      });
      let phone = $(this).data('product-item-phone');
      let item_handle = $(this).data('product-item-handle');
      let item_newhandle = $(this).data('product-new-handle');
      let item_newimage = $(this).data('product-new-image');
      let item_newmodel = $(this).data('product-item-brand');

      if (base_model_code) {
        var deleted_prefix = base_model_code.split('_')[1]
        var base_model_name = window.fox.settings.model[deleted_prefix];

        if(base_casetype_name.indexOf('h1_SP') !== -1 || base_casetype_name.indexOf('h1_CC') !== -1){
          base_model_name = $(this).data('product-item-brand');

          if(phone){
            base_model_name = phone;
            if(phone == 'iphone'){
              base_model_name = 'Apple iPhone';
            }
            if($(this).data('product-item-android')){
              base_model_name = $(this).data('product-item-android');
            }
          }

          if(item_newimage){
            $(this).find('img').attr('src',item_newimage);
            $(this).find('.product-item-image').css('background-image',`url(${item_newimage})`);
            $(this).find('.product-item-image').attr('data-bgset', '');
            $(this).find('.product-item-image').attr('data-bg-url', item_newimage);
          }
          if(item_newhandle){
            var new_link = $(this).find('a').attr('href').replace(item_handle,item_newhandle);
            $(this).find('a').attr('href',new_link);
          }
        }
        // console.log({base_model_name})
        $('.js-model',this).text(base_model_name);
      }
    })

    $('[data-get-newitem="true"]').each(async function(){
      const $this = $(this);
      const new_handle = $this.data('get-newhandle');

      try{
        const result = await fetch(`/products/${new_handle}.js`);
        const json = await result.json();
        if(json.featured_image){
          const feature_img = json.featured_image;
          $this.find('img').attr('src',feature_img);
          $this.find('img').attr('src',feature_img);
          $this.find('.product-item-image').css('background-image',`url(${feature_img})`);
          $this.find('.product-item-image').attr('data-bgset', '');
          $this.find('.product-item-image').attr('data-bg-url', feature_img);
        }
        if(json){
          $this.find('a').attr('href',json.url);
        }
      }catch(e){
        console.log(e)
        // $(this).remove();
      }

    })
  }

  async function setProductInfo(){

    function textTrim(text, count) {
      if (text.length > count) {
        var showText = text.substring(0, count);
        showText += '…';
        return showText;
      } else {
        return text;
      }
    }
    const labelTags = [];
    $('.js-section-product').each(function () {
      var tags = $(this).data('product-tags');
      if (Array.isArray(tags)) {
        tags.filter(function(tag) {
          return tag.indexOf('productname_') === 0;
        }).forEach(function(tag) {
          if (labelTags.indexOf(tag) === -1) labelTags.push(tag);
        });
      }
    });
    const tagLabels = await window.caseplayTagLabels.get(labelTags);

    $('.js-section-product').each(function () {
      var itemtitle = $(this).data('product-item-title');
      var tags = $(this).data('product-tags');
      var phone = $(this).data('product-item-phone');
      var base_model_code = tags.find(function (code) {
        return code.indexOf('mo_') === 0;
      });
      var base_casetype_name = tags.find(function(code) {
        return code.indexOf('h1_') === 0;
      });
      var base_itemtitle = tags.find(function (code) {
        return code.indexOf('productname_') === 0;
      });
      var hasBlackRingTag = tags.some(function (tag) {
        return tag.startsWith('cscl_') && tag.includes('ブラックリング');
      });
      base_itemtitle = (base_itemtitle && tagLabels[base_itemtitle]) || window.caseplayDisplayTitle(itemtitle, base_itemtitle);
      if (base_model_code) {
        var deleted_prefix = base_model_code.split('_')[1]
        var base_model_name = window.fox.settings.model[deleted_prefix];
        $('.js-model',this).text(base_model_name);
      }
      if (base_casetype_name){
        var base_casetype_name = window.fox.settings.h1[base_casetype_name];
        console.log('base_casetype_name' + base_casetype_name);
        $('.js-casetype',this).text(base_casetype_name);
        if(base_casetype_name == 'スリムプロテクションプレミアムケース with MagSafe ホワイトリング' && hasBlackRingTag) {
          console.log('ブラックリング!!!!!!!!!!');
          $('.js-casetype',this).text('スリムプロテクションプレミアムケース with MagSafe ブラックリング');
        }
      }
      if (base_itemtitle) {
        base_itemtitle = textTrim(base_itemtitle, 22);
        if (window.matchMedia('(max-width: 600px)').matches) {
          base_itemtitle = textTrim(base_itemtitle, 22);
        }
        $('.js-item-title',this).text(base_itemtitle);
      }
    });
  }


  async function setAllProducts(){

    // document.querySelector('[data-product-item-wrapper]').innerHTML = '';

    // if($('.product-item').length > 5) {
    //   return;
    // }
    const pagination = document.querySelector('.pagination');
    if(pagination){
      pagination.style.display = 'none';
    }
    const productItems = [];

    const url = new URL(window.location.href);
    const origin_url = url.toString();
    const params = url.searchParams;
    const models = [
      'AppleiPhone15Pro',
      'SamsungGalaxyS24',
      'SONYXperia5V',
      'SHARPAQUOSsense7',
      'GooglePixel9Pro',
      'Xiaomi13TPro',
      'OPPOReno7A',
      'Motorolamotog31',
      'FCNTarrowsWe',
      'HUAWEIHUAWEIP30lite',
      'ZTELiberoFlip'
    ];


    if(collection_template != 'collaboration' && collection_template != 'allview'){
      models.forEach(model => {
        url.searchParams.append('filter.p.m.custom.model', model);
      });
    }

    //paramsにsort_byがある場合はその値をセット
    const sort_by = url.searchParams.get('sort_by');
    if(sort_by){
      url.searchParams.append('sort_by', sort_by);
    }

    url.searchParams.append('view', 'ajax');
    const page = parseInt(url.searchParams.get('page')) || 1;
    // const maxPage = 600; // 最大ページ数を設定
    url.searchParams.append('page', page + 1);

    const xurl = url.toString();
    fetch(xurl, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(res => {
      console.log(res)
      return res.text()
    }).then(content => {
      // console.log(content);
      var tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      var productWrapper = tempElement.querySelector('#listwrapper');
      var productItem = productWrapper.querySelectorAll('.product-item')
      console.log(productItem.length)
      if(productItem.length > 0){
        for(var i = 0; i < productItem.length; i++){
          document.querySelector('[data-product-item-wrapper]').appendChild(productItem[i]);
        }

        setProductInfo();
        setWideModel();
        // 次のページを取得
        console.log({page, maxPage})
        if (page < maxPage) {
          // ページネーションの位置までっていったら読み込み
          const pagination = document.querySelector('.pagination-parts');
          if(pagination){
            pagination.scrollIntoView();
            url.searchParams.set('page', page + 2);
            fetchNextPage(url.toString());
          }
        }
      }else{
        console.log('no productItem')
        url.searchParams.set('page', page + 2);
        fetchNextPage(url.toString());

        return;
      }
    }).catch(error => {
      console.error('Error fetching products:', error);
    });


    function fetchNextPage(nextUrl) {

      console.log({nextUrl})
      const new_url = new URL(nextUrl);
      const page = parseInt(new_url.searchParams.get('page')) || 1;
      new_url.searchParams.set('page', page);
      fetch(nextUrl, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(res => {
        return res.text();
      }).then(content => {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        var productWrapper = tempElement.querySelector('#listwrapper');
        var productItem = productWrapper.querySelectorAll('.product-item');
        if (productItem.length > 0) {
          var count = 0;
          productItem.forEach(item => {
            document.querySelector('[data-product-item-wrapper]').appendChild(item);
            count++;
            // productItems.push(item);
          });
          setProductInfo();
          setWideModel();

          // 次のページを取得
          if (page < maxPage) {
            // ページネーションの位置までっていったら読み込み
            const pagination = document.querySelector('.pagination-parts');
            if(pagination){
              pagination.scrollIntoView();
              new_url.searchParams.set('page', page + 1);
              fetchNextPage(new_url.toString());
            }
          }
        }else{
          const nextPage = parseInt(new_url.searchParams.get('page')) + 1;
          if (nextPage <= maxPage) {
            new_url.searchParams.set('page', nextPage);
            console.log({new_url})
            fetchNextPage(new_url.toString());
          }

        }
      }).catch(error => {
        console.error('Error fetching next page:', error);
      });
    }

  }

})
